import { connect } from 'react-redux';
import { actions, selectors, constants } from 'app-webtech-core';
import { WATCH_CHANNEL } from 'app-source/routes/types';
import { LoadingComponent } from '../components/Loading';

const LoadingViews = {
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  REGULAR_LOADING: 'REGULAR_LOADING',
};

const isSlugNotFound = (state) => {
  const {
    payload: { slug },
    type,
  } = selectors.location.properties(state);

  let isNotFound = false;

  if (type === WATCH_CHANNEL) {
    const { slugs } = selectors.linearChannels.properties(state);
    isNotFound = !slugs.includes(slug);
  }

  // TODO: Once SSR work is done, this check can be back to 'isNotFound'
  return false;
};

let viewToDisplay;
const mapStateToProps = (state) => {
  const { status: playerStatus } = selectors.player.properties(state);
  const { LOADING, PAUSED, PLAYING } = constants.player.PLAYER_STATE_STATUSES;
  const isFinishedLoading = [PAUSED, PLAYING].includes(playerStatus);
  const isAppLoaded = playerStatus === LOADING;

  const isPageNotFound = isSlugNotFound(state) || selectors.location.isPageNotFound(state);
  if (!viewToDisplay) {
    viewToDisplay = isPageNotFound ? LoadingViews.PAGE_NOT_FOUND : LoadingViews.REGULAR_LOADING;
  }

  return {
    isFinishedLoading,
    viewToDisplay,
    isAppLoaded,
    page: selectors.location.page(state),
    vodContent: selectors.vodContent.properties(state),
  };
};

const mapDispatchToProps = {
  appLoaded: actions.application.appLoaded,
};

export const Loading = connect(mapStateToProps, mapDispatchToProps)(LoadingComponent);
